var map = {
	"./icon-active-sensor.svg": "83d3",
	"./icon-counter.svg": "ceeb",
	"./icon-energy-meter.svg": "3099",
	"./icon-plug.svg": "0375",
	"./icon-prod-redy.svg": "718c",
	"./icon-prod-shelly.svg": "75ac",
	"./icon-redy-small.svg": "b19f",
	"./icon-redy.svg": "8326",
	"./icon-sel-box-small.svg": "c4b3",
	"./icon-sel-box.svg": "bc40",
	"./icon-shelly-small.svg": "7784",
	"./icon-shelly.svg": "bff4",
	"./icon-state-critical.svg": "ed28",
	"./icon-state-down.svg": "c410",
	"./icon-state-up.svg": "cb41",
	"./icon-temp-sensor.svg": "115b",
	"./icon-voltaware.svg": "b5a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec94";